import { useContext } from "react";
import { Context as FarmsContext } from "../contexts/Farms";

const useFarmPrice = () => {
  const { price } = useContext(FarmsContext);
  return [price];
};

export default useFarmPrice;
